module.exports = __webpack_public_path__ + "img/sld_mfm_battery_1_t1_b1_dark.6f621404.svg";